import Vue from 'vue'
import VModal from 'vue-js-modal/dist/ssr.index'

Vue.use(VModal)



// WEBPACK FOOTER //
// ./plugins/modalPlugin.js